// extracted by mini-css-extract-plugin
export default {"root":"PanelHeader_root__mOKe3","container":"PanelHeader_container__ZaBFC","panelName":"PanelHeader_panelName__4zXqM","minimizeContainer":"PanelHeader_minimizeContainer__BBj+A"};